import gsap from"gsap";

let tvCurrXPerc = 0;
let prevTvCurrXPerc = 0;
let dualCtaRaf;
let dualCtas;

function renderDualCta(){
    dualCtas.forEach(dualCta => {
        if(dualCta.isInView){
            if(prevTvCurrXPerc !== tvCurrXPerc){
                dualCta.children[0].style.width = (tvCurrXPerc + 53) + "%";
                dualCta.children[1].style.width = (47 - (tvCurrXPerc)) + "%";

                prevTvCurrXPerc = tvCurrXPerc;
            }
        }
    });

    dualCtaRaf = requestAnimationFrame(renderDualCta);
}

function calcDualTv(e){
    tvCurrXPerc = (-(((e.x) / (window.innerWidth * 15)) * 100));
}

export default function initDualCta(){
    dualCtas = document.querySelectorAll(".dual-cta");

    dualCtas.forEach(dualCta => {
        dualCta.isInView = false;

        gsap.to(dualCta, {
            scrollTrigger: {
                trigger: dualCta,
                start: "top bottom",
                end: "bottom top",
                once: false,

                onEnter: () => { dualCta.isInView = true; },
                onEnterBack: () => { dualCta.isInView = true; },
                onLeave: () => { dualCta.isInView = false; },
                onLeaveBack: () => { dualCta.isInView = false; }
            },
        });
    });

    document.addEventListener("mousemove", calcDualTv);
    renderDualCta();

    const dualCtaImgs = document.querySelectorAll(".dual-cta__item__img");
    dualCtaImgs.forEach(dualCtaImg => {
        gsap.fromTo(dualCtaImg, { scale: 1.3 }, {
            scrollTrigger: {
                trigger: dualCtaImg.parentElement,
                start: "top bottom-=20%",
                once: true,
            },

            scale: 1.15,
            duration: .8,
            ease: "ease-out"
        });
    });
}